<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>NFS-e Status</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
                <mat-icon>fullscreen_exit</mat-icon>
            </button>
            <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
                <mat-icon>fullscreen</mat-icon>
            </button>
            <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
                <mat-icon>close</mat-icon>
            </button>

    </div>
  </div>
</mat-toolbar>
<mat-dialog-content>
  <div class="md-dialog-content">
    <br />
    <div class="row">
      <div class="table-responsive col-md-12">
        <table class="table table-striped" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th>Data</th>
              <th>Status</th>
              <th>Descrição</th>
              <th>Detalhe</th>
              <th>Protocolo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let status of nfsesStatus">
              <td>{{status.dataCriacao | date:'dd/MM/yyyy HH:mm:ss'}}</td>
              <td>{{status.codStatus}}</td>
              <td>{{status.descricao}}</td>
              <td>
                <button mat-mini-fab (click)="modalStatusDetalhe(status.detalhe)"
                  *ngIf="status.detalhe != undefined && status.detalhe != null && status.detalhe != ''" matTooltip="Detalhes">
                  <mat-icon>info</mat-icon>
                </button>
              </td>
              <td>{{status.nProt}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</mat-dialog-content>
